import React, { useRef, useContext } from 'react'

import { Route, Routes,useNavigate } from "react-router-dom";
import Container from '@mui/material/Container';
import smoothscroll from 'smoothscroll-polyfill';
 
import { Redirect, useLocation} from 'react-router-dom';

// **** CUSTOM IMPORTS


import FrameworkTop from './FrameworkTop';
import FrameworkWhat from './FrameworkWhat';
import FrameworkHow from './FrameworkHow';
import FrameworkWhy from './FrameworkWhy';
import FrameworkRoadmap from './FrameworkRoadmap' ;
import FrameworkHelp from './FrameworkHelp' ;
import FrameworkConsulting from './FrameworkConsulting' ;

import AboutTop from './AboutTop'
import AboutHelp from './AboutHelp'
import AboutWho from './AboutWho'
import AboutConsulting from './AboutConsulting'

import DocumentationTop from './DocumentationTop' ;

import DocumentationReplicator from './DocumentationReplicator' ;
import DocumentationComplete from './DocumentationComplete' ;
import DocumentationICPM from './DocumentationICPM' ;
import DocumentationUplink from './DocumentationUplink' ;
import DocumentationWorkerdocker from './DocumentationWorkerdocker' ;

import Terms from './Terms' ;

import PilotProgramTop from './PilotProgramTop' ;

import PipeDivider from '../nav/PipeDivider' ;
import FooterMain from '../nav/FooterMain';
import MainAppBar from '../nav/MainAppBar';

import AppContext from '../nav/AppContext';

const Stage = () => {

  const myContext = useContext(AppContext);

  const refFrameworkTop = useRef();
  const refFrameworkWhat = useRef();
  const refFrameworkHow = useRef();
  const refFrameworkWhy= useRef();
  const refFrameworkRoadmap = useRef();
  const refFrameworkHelp = useRef();
  const refFrameworkConsulting =  useRef();

  const refAboutTop = useRef();
  const refAboutHelp = useRef();
  const refAboutWho = useRef();
  const refAboutConsulting = useRef();

  const refDocumentationTop = useRef();
  const refDocumentationReplicator = useRef();
  const refDocumentationComplete = useRef();
  const refDocumentationICPM = useRef();
  const refDocumentationUplink = useRef();
  const refDocumentationWorkerdocker = useRef();

// kick off the polyfill!
smoothscroll.polyfill();



let navigate = useNavigate();
let location = useLocation();



const checkLocation =  (thisLocation) => {
  let sameLocation = true ;
  if (thisLocation != location.pathname) {
    sameLocation = false ;
    navigate (thisLocation)
    
  }
  return sameLocation
} // end checkLocation


const mainNavClick =  (whereTo) => {
  event.preventDefault();        
  console.log ("NavItems-mainNavClick - start mainNavClick");
  console.log (whereTo);
  if (whereTo == "Framework") {
    if ( checkLocation ("/framework" ) ) {
      refFrameworkTop.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      document.body.scrollIntoView("alignToTop");
    }// end if check location
    
  } else if (whereTo == "FrameworkWhat") {
    checkLocation ("/framework" );
    refFrameworkWhat.current.scrollIntoView({ behavior: 'smooth' });
  } else if (whereTo == "FrameworkHow") {
    checkLocation ("/framework" );
    refFrameworkHow.current.scrollIntoView({ behavior: 'smooth' });
  } else if (whereTo == "FrameworkWhy") {
    checkLocation ("/framework" );
    refFrameworkWhy.current.scrollIntoView({ behavior: 'smooth' });
  } else if (whereTo == "FrameworkRoadmap") { 
    checkLocation ("/framework" );
    refFrameworkRoadmap.current.scrollIntoView({ behavior: 'smooth'});
  } else if (whereTo == "FrameworkHelp") { 
    checkLocation ("/framework" );
    refFrameworkHelp.current.scrollIntoView({ behavior: 'smooth'});
  } else if (whereTo == "FrameworkConsulting") { 
    checkLocation ("/framework" );
    refFrameworkConsulting.current.scrollIntoView({ behavior: 'smooth'});
  } else if (whereTo == "About") { 
    if ( checkLocation ("/about" ) ) {
      refAboutTop.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      document.body.scrollIntoView("alignToTop");
    }// end if check location
    
  } else if (whereTo == "AboutHelp") {
    checkLocation ("/about" );
    refAboutHelp.current.scrollIntoView({ behavior: 'smooth' });
  } else if (whereTo == "AboutWho") {
    checkLocation ("/about" );
    refAboutWho.current.scrollIntoView({ behavior: 'smooth' });
  } else if (whereTo == "AboutConsulting") {
    checkLocation ("/about" );
    refAboutConsulting.current.scrollIntoView({ behavior: 'smooth' });

  } else if (whereTo == "Documentation") { 
    if ( checkLocation ("/documentation" ) ) {
      refDocumentationTop.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      document.body.scrollIntoView("alignToTop");
    }// end if check location
    
  } else if (whereTo == "DocumentationReplicator") {
    checkLocation ("/documentation" );
    refDocumentationReplicator.current.scrollIntoView({ behavior: 'smooth' });
  } else if (whereTo == "DocumentationComplete") {
    checkLocation ("/documentation" );
    refDocumentationComplete.current.scrollIntoView({ behavior: 'smooth' });
  } else if (whereTo == "DocumentationICPM") {
    checkLocation ("/documentation" );
    refDocumentationICPM.current.scrollIntoView({ behavior: 'smooth' });
  } else if (whereTo == "DocumentationUplink") {
    checkLocation ("/documentation" );
    refDocumentationUplink.current.scrollIntoView({ behavior: 'smooth' });
  } else if (whereTo == "DocumentationWorkerdocker") {
    checkLocation ("/documentation" );
    refDocumentationWorkerdocker.current.scrollIntoView({ behavior: 'smooth' });

  } else if (whereTo == "Terms") {
    checkLocation ("/terms" );
    document.body.scrollIntoView("alignToTop");
  
  } else if (whereTo == "Pilot") {
    // checkLocation ("/pilot" );
    // document.body.scrollIntoView("alignToTop");
    window.open ("https://icpipeline.com/pilot", "_blank" );
  
  } else if (whereTo == "Home") { 
  
    if ( checkLocation ("/framework" ) ) {
      refFrameworkTop.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      document.body.scrollIntoView("alignToTop");
    }// end if check location

  } else if (whereTo == "YouTube") {
  
    window.open ("https://www.youtube.com/channel/UCeQhGnqjfdwPnCJgTdBrLQg", "_blank" );

  } else if (whereTo == "JoinTheMailingList") {
  
    window.open ("https://ldiux-kaaaa-aaaah-aaoea-cai.raw.ic0.app/", "_blank" );

  } else if (whereTo == "Dfinity") {
  
    window.open ("https://dfinity.org/", "_blank" );

  } else if (whereTo == "GitHub") {
  
    window.open ("https://github.com/icpipeline-framework/icpipeline-complete-beta", "_blank" );
  
  } else if (whereTo == "Calendly") {
  
    window.open ("https://calendly.com/icpipeline/icpipeline-quick-connect?", "_blank");

  } else if (whereTo == "Discord") {
  
    window.open ("https://discord.gg/Uy2qJQV4AS", "_blank");

  } else if (whereTo == "DiscordExplorers") {
  
    window.open ("https://discord.gg/3EybPCvnm8", "_blank");

  } else if (whereTo == "Twitter") {
  
    window.open ("https://twitter.com/icpipeline", "_blank");
  
  } else if (whereTo == "LinkedInBeekman") {
  
    window.open ("https://linkedin.com/in/mbeekman", "_blank");

  } else if (whereTo == "LinkedInRyan") {
  
    window.open ("https://www.linkedin.com/in/daniel-ryan-a1410770", "_blank");

  } else {
    document.body.scrollIntoView("alignToTop");
  }
  
  



} // end handle click

  var frameworkDisplay = [
    <Container key={1}  ref={refFrameworkTop} sx={{pt:8, 
      backgroundColor:"#c60"}}>
        <PipeDivider theHeight="100px"  />
        <FrameworkTop mainNavClick={mainNavClick} />
        <PipeDivider refProp={refFrameworkWhat} />
        <FrameworkWhat mainNavClick={mainNavClick}  />
        {/* <PipeDivider refProp={refFrameworkHow} />
        <FrameworkHow mainNavClick={mainNavClick} /> */}
        {/* <PipeDivider refProp={refFrameworkWhy} />
        <FrameworkWhy mainNavClick={mainNavClick} />
        <PipeDivider refProp={refFrameworkRoadmap} />
        <FrameworkRoadmap mainNavClick={mainNavClick} /> */}
        <PipeDivider refProp={refFrameworkHelp} />
        <FrameworkHelp mainNavClick={mainNavClick} />
        <PipeDivider refProp={refFrameworkConsulting} />
        <FrameworkConsulting mainNavClick={mainNavClick} />
        <PipeDivider />
      </Container>
  ] ; /// end frameworkDisplay 

  
  var documentationDisplay = [
    <Container key={1}  ref={refDocumentationTop} sx={{pt:8, 
      backgroundColor:"#c60"}}>
      <PipeDivider theHeight="100px"  />
        <DocumentationTop mainNavClick={mainNavClick}/>
      <PipeDivider refProp={refDocumentationReplicator}  />
        <DocumentationReplicator mainNavClick={mainNavClick}/>
      <PipeDivider refProp={refDocumentationComplete}  />
        <DocumentationComplete mainNavClick={mainNavClick}/>
      <PipeDivider refProp={refDocumentationICPM}  />
        <DocumentationICPM mainNavClick={mainNavClick}/>
      <PipeDivider refProp={refDocumentationUplink}  />
        <DocumentationUplink mainNavClick={mainNavClick}/>
      <PipeDivider refProp={refDocumentationWorkerdocker}  />
        <DocumentationWorkerdocker mainNavClick={mainNavClick}/>
        <PipeDivider />
      </Container>
  ] ; /// end documentationDisplay  

  var aboutDisplay = [
    <Container key={1}  ref={refAboutTop} sx={{pt:8, 
      backgroundColor:"#c60"}}>
        <PipeDivider theHeight="100px" />
        <AboutTop mainNavClick={mainNavClick}/>
        <PipeDivider refProp={refAboutHelp} />
        <AboutHelp mainNavClick={mainNavClick}/>
        <PipeDivider refProp={refAboutWho} />
        <AboutWho mainNavClick={mainNavClick}/>
        <PipeDivider refProp={refAboutConsulting} />
        <AboutConsulting mainNavClick={mainNavClick}/>
        <PipeDivider />
      </Container>
  ] ; /// end aboutDisplay  

  var termsDisplay = [
    <Container key={1}  ref={refDocumentationTop} sx={{pt:8, 
      backgroundColor:"#c60"}}>
      <PipeDivider theHeight="100px"  />
        <Terms mainNavClick={mainNavClick}/>
        <PipeDivider />
      </Container>
  ] ; /// end termsDisplay  

  var pilotDisplay = [
    <Container key={1}  ref={refDocumentationTop} sx={{pt:8, 
      backgroundColor:"#c60"}}>
      <PipeDivider theHeight="100px"  />
        <PilotProgramTop mainNavClick={mainNavClick}/>
        <PipeDivider />
      </Container>
  ] ; /// end pilotDisplay  

  return (
    <React.Fragment>
      <MainAppBar mainNavClick={mainNavClick} />
    
            <Routes>
                <Route path="/" element={frameworkDisplay} />
                <Route path="/framework" element={frameworkDisplay} />
                <Route path="/documentation" element={documentationDisplay} />
                <Route path="/about" element={aboutDisplay} />
                <Route path="/terms" element={termsDisplay} />
                <Route path="/pilot" element={pilotDisplay} />
                
            </Routes>
      <FooterMain mainNavClick={mainNavClick}  />

    </React.Fragment>
  );
} // end Stage


export default Stage;